import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { analytics } from './client';

export function RouteAnalytics() {
  const { pathname } = useLocation();
  useEffect(() => analytics.pageView(pathname), [pathname]);
  return null;
}
